document.addEventListener("DOMContentLoaded", () => {
  const dom = {};
  const qsAll = {
    heroSliderContainer: "data-js-tns-slider-section",
    heroSlider: "data-hero-slider",
    prevBtn: "data-js-tns-prevBtn",
    nextBtn: "data-js-tns-nextBtn",
    youtubeVideo: "data-youtube-iframe",
    brandCarouselContainer: "data-brand-carousel-container",
    brandCarousel: "data-brand-carousel",
    brandCarouselControls: "data-brand-carousel-controls",
  };


  const cacheElements = () => {
    dom.heroSliderContainer = document.querySelector(
      `[${qsAll.heroSliderContainer}]`
    );
    dom.heroSliders = document.querySelectorAll(`[${qsAll.heroSlider}]`);
    dom.prevBtn = document.querySelector(`[${qsAll.prevBtn}]`);
    dom.nextBtn = document.querySelector(`[${qsAll.nextBtn}]`);
    dom.brandCarousel = document.querySelector(`[${qsAll.brandCarousel}]`);
  };

  const generateCarousels = () => {

    if (!dom.heroSliderContainer) return;

    document.querySelectorAll(`[data-hero-slider]`).forEach((slider) => {
      const sliderContainer = slider.closest(`[${qsAll.heroSliderContainer}]`);
      const sliderControls = sliderContainer.querySelector(
        `[${qsAll.heroSliderContainer}]`
      );

      const autoPlay = slider.dataset.jsTnsAutoplay === "true";
      const autoPlayTimeout = autoPlay ? parseInt(slider.dataset.jsTnsAutoplayTimeout) : 0;

      const settings = {
        container: slider,
        nav: true,
        items: 1,
        slideBy: "page",
        autoplay: autoPlay,
        autoplayTimeout: autoPlayTimeout,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        animateDelay: 2000,
        lazyload: true,
        mouseDrag: true,
        prevButton: dom.prevBtn,
        nextButton: dom.nextBtn,
        preventScrollOnTouch: "auto",
      };

      tns(settings);
    });
  };

  const generateBrandCarousel = () => {
    if (dom.brandCarousel && dom.brandCarousel.childNodes.length > 1) {
      const brandCarouselContainer = dom.brandCarousel.closest(
        `[${qsAll.brandCarouselContainer}]`
      );
      const brandCarouselControls = brandCarouselContainer.querySelector(
        `[${qsAll.brandCarouselControls}]`
      );

      tns({
        container: dom.brandCarousel,
        items: 1,
        slideBy: 1,
        controls: true,
        controlsContainer: brandCarouselControls,
        nav: true,
        navPosition: "bottom",
        mouseDrag: true,
        responsive: {
          768: {
            items: 2,
          },
          1024: {
            items: 3,
          },
        },
      });
    }
  };

  cacheElements();
  generateCarousels();
  generateBrandCarousel();

  document.addEventListener("shopify:section:load", function (event) {
    generateCarousels();
    generateBrandCarousel();
  });

});


